import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const auditLogdApi = createApi({
  reducerPath: "base/auditLog",
  baseQuery: axiosBaseQuery,
  tagTypes: ["logList"],
  endpoints: (builder) => ({
    auditLog: builder.query<{ data: any[]; success: any }, string | void>({
      providesTags: ['logList'],
      query: (query = '') => ({
        url: "/base/auditLog" + query,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        // console.log(response?.data)
        return {
          data: response?.data,
          success: response?.success,
        };
      },
    }),
  })
})

export const { useAuditLogQuery } = auditLogdApi;
export { auditLogdApi };
